import { Navigate, Route, Routes } from 'react-router-dom';

import withPermission from 'hooks/withPermission';

import { PATH } from 'constants/path';

import { LearnerLayout } from './component/LearnerLayout';
import { AddLearnerPage } from './page/AddLearnerPage';
import { LearnerDetailPage } from './page/LearnerDetailPage';
import { LearnerPage } from './page/LearnerPage';

const LearnerRoutes = () => (
  <Routes>
    <Route element={<LearnerLayout />}>
      <Route path="" element={<LearnerPage />} />
      <Route element={<Navigate to="" />} />
    </Route>
    <Route path={`${PATH.LEARNER_ADD}`} element={<AddLearnerPage />} />
    <Route path={`${PATH.LEARNER_EDIT}`} element={<LearnerDetailPage />} />
    <Route path="*" element={<Navigate to={PATH.ERROR_404} />} />
  </Routes>
);

export default withPermission(['Clients'])(LearnerRoutes);
